import { ProductAnalytics } from './components/ProductAnalytics';
import { ProductGroupMembership } from './components/ProductGroupMembership';
import { ProductOrganization } from './components/ProductOrganization';
import { ProductPage } from './components/ProductPage';
import { ProductRegistrationChannels } from './components/ProductRegistrationChannels';
import { ProductStatus } from './components/ProductStatus';
import { ProductSummary } from './components/ProductSummary';
import { ProductVariantList } from './components/ProductVariantList';
import { ProductForm } from './ProductForm';
import { ProductProvider } from './ProductProvider';

export default function ProductDetailPage() {
  return (
    <ProductProvider>
      <ProductPage>
        <ProductForm>
          <div className="space-y-4">
            <ProductSummary />
            <ProductAnalytics />
            <div className="grid grid-cols-1 gap-4 md:grid-cols-[3fr_1fr]">
              <ProductVariantList />
              <div className="space-y-4">
                <ProductStatus />
                <ProductOrganization />
                <ProductRegistrationChannels />
                <ProductGroupMembership />
              </div>
            </div>
          </div>
        </ProductForm>
      </ProductPage>
    </ProductProvider>
  );
}
